import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import ItemAtendimento from "./item_atendimento";
import { connect } from "react-redux";
import { getPrestador, updatePrestador } from "@store/actions/index";
import m from "@utils/strings";
import AjaxLoader from "./shared/ajax_loader";
import _ from "lodash";

const styles = {
  divExterna: {
    margin: "auto",
  },
  divInterna: {
    textAlign: "center",
    marginTop: 15,
    marginBottom: 15,
  },
  label: {
    width: 600,
    height: 24,
    color: "#333333",
    fontFamily: "Work Sans",
    fontSize: 20,
    fontWeight: 400,
    margin: 15,
  },
};

interface ISelecaoAtendimentoProps extends React.ComponentProps<"div"> {
  user?: any;
  prestador?: any;
  getPrestador?: any;
  updatePrestador?: any;
  classes?: any;
}

function SelecaoAtendimento(props: ISelecaoAtendimentoProps) {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);

  const getUpdatePrestador = () => {
    const { user } = props;
    if (user != null && user.profile != null) {
      if (!isLoading) {
        setLoading(true);
        let cpfCnpj =
          user.profile.prestador instanceof Array
            ? user.profile.prestador[0]
            : user.profile.prestador;
        props.getPrestador(cpfCnpj, (result: any) => {
          props.updatePrestador(result);
          setLoading(false);
        });
      }
    } else {
      setTimeout(() => {
        getUpdatePrestador();
      }, 800);
    }
  };

  const handleKeyDown = (event: any) => {
    switch (event.key) {
      case "F4":
        navigate("/atendimento/consulta-pronto-socorro");
        break;
      case "F7":
        navigate("/atendimento/exames-procedimentos-pronto-socorro");
        break;
      case "F8":
        navigate("/atendimento/exames-procedimentos-eletivos");
        break;
      case "F9":
        navigate("/atendimento/consulta-eletiva");
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (_.isEmpty(props.prestador)) {
      getUpdatePrestador();
    }
    document.addEventListener("keydown", handleKeyDown, false);
    return () => {
      document.removeEventListener("keydown", handleKeyDown, false);
    };
  }, []);

  const { classes } = props;
  const prestadorLoader = isLoading ? (
    <AjaxLoader
      ajaxMessage={
        m.TELA_CONSULTA_PRONTO_SOCORRO.MENSAGEM_LOADER_BUSCANDO_PRESTADOR
      }
    />
  ) : (
    ""
  );

  return (
    <div className={classes.divExterna}>
      {prestadorLoader}
      <div className={classes.divInterna}>
        <label className={classes.label}>
          {m.TELA_SELECIONAR_ATENDIMENTO.LABEL_ACIMA_BOTOES_ATENDIMENTO}
        </label>
      </div>
      <div className={classes.divExterna}>
        <div className={classes.divInterna}>
          <ItemAtendimento
            iconePath="../images/consulta_ps.png"
            alt={m.TELA_SELECIONAR_ATENDIMENTO.TITULO_ACCORDION_CONSULTA_PS}
            content={`${m.TELA_SELECIONAR_ATENDIMENTO.TITULO_ACCORDION_CONSULTA_PS} (F4)`}
            redirect_path="/atendimento/consulta-pronto-socorro"
          />
        </div>
      </div>
      <div className={classes.divExterna}>
        <div className={classes.divInterna}>
          <ItemAtendimento
            iconePath="../images/procedimentos_ps.png"
            alt={m.TELA_SELECIONAR_ATENDIMENTO.TITULO_ACCORDION_EXAMES_PS}
            content={`${m.TELA_SELECIONAR_ATENDIMENTO.TITULO_ACCORDION_EXAMES_PS} (F7)`}
            redirect_path="/atendimento/exames-procedimentos-pronto-socorro"
          />
        </div>
      </div>
      <div className={classes.divExterna}>
        <div className={classes.divInterna}>
          <ItemAtendimento
            iconePath="../images/procedimentos_lab.png"
            alt={m.TELA_SELECIONAR_ATENDIMENTO.TITULO_ACCORDION_EXAMES_ELETIVOS}
            content={`${m.TELA_SELECIONAR_ATENDIMENTO.TITULO_ACCORDION_EXAMES_ELETIVOS} (F8)`}
            redirect_path="/atendimento/exames-procedimentos-eletivos"
          />
        </div>
      </div>
      <div className={classes.divExterna}>
        <div className={classes.divInterna}>
          <ItemAtendimento
            iconePath="../images/consulta_eletiva.png"
            alt={
              m.TELA_SELECIONAR_ATENDIMENTO.TITULO_ACCORDION_CONSULTA_ELETIVA
            }
            content={`${m.TELA_SELECIONAR_ATENDIMENTO.TITULO_ACCORDION_CONSULTA_ELETIVA} (F9)`}
            redirect_path="/atendimento/consulta-eletiva"
          />
        </div>
      </div>
    </div>
  );
}

//@ts-ignore
function mapStateToProps(state) {
  return {
    user: state.oidc.user,
    prestador: state.prestador,
  };
}

//@ts-ignore
export default withStyles(styles)(
  connect(mapStateToProps, { getPrestador, updatePrestador })(
    SelecaoAtendimento
  )
);
